import React from "react";
import { Datagrid, List, TextField } from "react-admin";
import { CustomDateField } from "../../../../Components/CustomDateField";

const WhList = props => {
  return (
    <List
      {...props}
      resource="whs/getSubPns"
      basePath="whs"
      filter={
        props.isPbh ? { pn__eq: props.pn, isPbh__eq: true, requestId__eq: props.requestId } : { pn__eq: props.pn }
      }
      perPage={10}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid
        id="guid"
        rowStyle={(record, index) => ({
          backgroundColor:
            record.pn != record.mainPn
              ? record.isAlternatePnOffered
                ? "#2977fc75"
                : record.isAlternatePnAccepted
                  ? "#198754"
                  : record.isAlternatePnRejected
                    ? "#c90c0f"
                    : "#eeee9b"
              : "white",
        })}
      >
        <TextField source="pn" />
        <TextField source="sn" />
        <TextField source="shelf1" />
        <TextField source="shelf2" />
        <TextField source="tbo" />
        <TextField source="tbr" />
        <CustomDateField source="birthDate" />
        <TextField source="componentAge" />
        <TextField source="condition" />
        <TextField source="location" />
        <TextField source="qtyInTransfer" />
        <TextField source="toLocation" />
      </Datagrid>
    </List>
  );
};

export default WhList;
